<script setup>
import IconContentCopy from '@/Components/Icons/IconContentCopy.vue';
import { reactive } from 'vue';
import IconCheckCircle from '@/Components/Icons/IconCheckCircle.vue';

const props = defineProps({
  copyText: {
    type: String,
    required: true
  },
  datadogActionName: {
    type: String,
    default: null
  }
});

const state = reactive({
  copied: false
});

const copy = () => {
  state.copied = true;
  navigator.clipboard.writeText(props.copyText);
  setTimeout(() => {
    state.copied = false;
  }, 2500);
};
</script>

<template>
  <div
    class="bg-background rounded-xl p-2 transition duration-200"
    :class="{ 'hover:bg-white-700': !state.copied }"
    @click="copy"
    :data-dd-action-name="props.datadogActionName"
  >
    <IconContentCopy v-if="!state.copied" class="text-background-content" />
    <div v-else class="flex items-end justify-between gap-2">
      <div class="text-success font-bold">
        {{ $t('components.button.copy_button.copied') }}
      </div>
      <IconCheckCircle class="text-success" />
    </div>
  </div>
</template>
